import { Link, useParams } from 'react-router-dom';
import apiMethod from '../../../services/api-service';
import methods from '../../../services/utility';
import { useState, useEffect } from 'react';
import DeleteModal from '../../../components/deleteModal/DeleteModal';

// assets
import back from "../../../assets/images/icons/arrow-right2.svg";
import Preloading from '../../../components/basics/Preloading';

const Printer = () => {
  const { branchId } = useParams();
  const [gridData, setGridData] = useState([]);
  const [localPrinters, setlocalPrinters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [localService, setLocalService] = useState({
    baseUrl: ""
  });
  const [filterModel, setFilterModel] = useState({
    branchId: branchId,
    title: '',
    size: 20,
    part: 1,
    total: 0,
    parts: 0
  });
  const [formModel, setFormModel] = useState({
    id: 0,
    title: "",
    name: "",
    ipAddress: "",
    code: "",
    printerUnitType: 0,
    branchId: branchId
  });

  const getSettings = async () => {
    const resp = await apiMethod.getSettingByName(branchId, "LocalServices");
    if (!methods.showApiErrors(resp))
      return false;

    let settings = JSON.parse(resp.data.settingItems);
    let setting = await settings.find(x => x.KeyName === 'HostPath');
    localService.baseUrl = setting.SettingValue;
    setLocalService({ ...localService });
  }

  const getPrinterNames = async () => {
    if (methods.isNullOrEmptyString(localService.baseUrl)) {
      methods.showErrors(['در تنظیمات سیستم لطفا مقدار سرویس هاست بررسی شود.']);
      return false;
    }
    const localPrintersResp = await apiMethod.getLocalPrinters(localService.baseUrl);
    if (methods.showApiErrors(localPrintersResp))
      setlocalPrinters(localPrintersResp.data);
  }

  const getGridData = async () => {
    const resp = await apiMethod.getPrinters(filterModel.branchId, filterModel.title, filterModel.size, filterModel.part);
    if (methods.showApiErrors(resp)) {
      filterModel.total = resp.total;
      filterModel.parts = methods.calcPageParts(resp.total, filterModel.size);
      setFilterModel({ ...filterModel });
      setGridData(resp.data);
    }
  };

  useEffect(() => {
    const bindData = async () => {
      setLoading(true);
      await getSettings();
      await getGridData();
      await getPrinterNames();
      setLoading(false);
    }
    bindData();
  }, [branchId]);

  const validForm = () => {
    let errors = [];
    if (methods.isNullOrEmptyString(formModel.title)) {
      errors.push('.عنوان باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.code)) {
      errors.push('.دستگاه در شبکه باید مقدار داشته باشد');
    }
    if (methods.isNullOrEmptyString(formModel.printerUnitType) || formModel.printerUnitType === 0) {
      errors.push('.جایگاه دستگاه در شبکه باید مقدار داشته باشد');
    }
    if (errors.length > 0) {
      methods.showErrors(errors);
      return false;
    }
    return true;
  };

  const resetForm = () => {
    formModel.id = 0;
    formModel.title = "";
    formModel.code = "";
    formModel.name = "";
    formModel.ipAddress = "";
    formModel.printerUnitType = "";
    formModel.branchId = branchId;
    setFormModel({ ...formModel });
    setShowFormModal(false);
  };

  const resetFilters = () => {
    filterModel.branchId = branchId;
    filterModel.title = '';
    filterModel.size = 20;
    filterModel.part = 1;
    setFilterModel({ ...filterModel })
  };

  const editItem = async (id) => {
    setLoading(true);
    const resp = await apiMethod.getPrinterInfo(id);
    if (!methods.showApiErrors(resp))
      return false;

    formModel.id = resp.data.id;
    formModel.code = resp.data.code;
    formModel.title = resp.data.title;
    formModel.name = resp.data.name;
    formModel.ipAddress = resp.data.ipAddress;
    formModel.printerUnitType = resp.data.printerUnitType;
    formModel.branchId = resp.data.branchId;
    setFormModel({ ...formModel });
    setShowFormModal(true);
    setLoading(false);
  };

  const createNewItem = async (e) => {
    if (!validForm())
      return false;

    setLoading(true);

    try {
      const resp = await apiMethod.createPrinter(formModel);

      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowFormModal(false);
    }
  };

  const searchItem = async () => {
    setLoading(true);
    await getGridData();
    setLoading(false);
  };

  const clearSearch = async () => {
    setLoading(true);
    resetFilters();
    await getGridData();
    setLoading(false);
  };

  const movePagerPart = (isForward) => {
    if (isForward) {
      if (filterModel.parts < filterModel.part + 1) {
        return false;
      }
      callPager(filterModel.part + 1);
    } else {
      if (filterModel.part === 1) {
        return false;
      }
      callPager(filterModel.part - 1);
    }
  };

  const callPager = async (i) => {
    setLoading(true);
    filterModel.part = i;
    setFilterModel({ ...filterModel });
    await getGridData();
    setLoading(false);
  };

  const makePagerItems = () => {
    let pages = [];
    for (let i = 1; i <= filterModel.parts; i++) {
      pages.push(
        <li key={i} className={filterModel.part === i ? 'page-item active mx-1' : 'page-item mx-1'}>
          <a className="page-link circular-pagination" onClick={() => { callPager(i) }}>
            {i}
          </a>
        </li>
      );
    }
    return pages;
  };


  const renderItems = () => {
    return (
      <>
        {loading && <Preloading></Preloading>}
        {
          <>
            <div className='d-none d-lg-flex justify-content-start align-items-baseline mb-3'>
              <Link to={`/sale/${branchId}/#3`} className='link back-link'>
                <span><img src={back} className="" alt="return" /></span>
                بازگشت
              </Link>
            </div>
            <div className='d-lg-none d-flex justify-content-between align-items-baseline saleheader'>
              <div>
                <Link to={`/sale/${branchId}/#3`} className='link back-link'>
                  <span><img src={back} className="" alt="return" /></span>
                </Link>
                تنظیمات پرینترها
              </div>
              <p className="date">{methods.currentDate()}</p>
            </div>
            <div className='saleheader d-none d-lg-block'>
              <p>تنظیمات پرینترها
                <a href={`/sale/${branchId}/softwareGuide/#section7`} className="link rtlicon me-1" title="برای اطلاعات بیشتر کلیک کنید" target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-question-circle"></i>
                </a>
              </p>
            </div>
            <div className="salemain">
              <div className='salesearchsection'>
                <div className='row g-1'>
                  <div className='col-12 col-md-6 col-lg-4'>
                    <label htmlFor="funit" className="form-label">عنوان</label>
                    <div className="hstack">
                      <input
                        id="searchInput"
                        className="form-control"
                        type="text"
                        aria-label="Add your item here..."
                        style={{ direction: 'rtl', textAlign: 'right' }}
                        value={filterModel.title}
                        onChange={(e) => { setFilterModel({ ...filterModel, title: e.target.value, part: 1 }) }}
                      />
                      <button type='button' className='btn btn-purple me-1'
                        onClick={searchItem}
                      >
                        <i className="bi bi-search"></i>
                      </button>
                      <button type='button' className='btn btn-outline-info'
                        onClick={clearSearch}
                      >
                        <i className="bi bi-arrow-clockwise"></i>
                      </button>
                    </div>
                  </div>
                  <div className='col-12 col-md-2 col-lg-4'></div>
                  <div className='col-12 col-md-4'>
                    <div className='createButton'>
                      <button
                        onClick={() => { openNewForm() }}
                        className='btn btn-outline-purple custome-btn' type='button'>
                        <span className='align-middle d-inline-block'>پرینتر جدید</span> <i className="bi bi-plus-circle align-middle"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className='table-responsive saletable'>
                <table className="table table-striped table-md " >
                  <thead className='align-middle'>
                    <tr>
                      <th scope="col vertical-center" width="20px">ردیف</th>
                      <th scope="col vertical-center">عنوان</th>
                      <th scope="col vertical-center"> نام انگلیسی</th>
                      <th scope="col vertical-center"> IP</th>
                      <th scope="col vertical-center" width="100px">عملیات</th>
                    </tr>
                  </thead>
                  <tbody className='align-middle'>
                    {gridData.map((printer, index) => (
                      <tr key={printer.id}>
                        <th scope="row">{((filterModel.part - 1) * filterModel.size) + index + 1}</th>
                        <td>{printer.title}</td>
                        <td>{printer.name}</td>
                        <td>{printer.ipAddress}</td>
                        <td>
                          <button
                            onClick={() => editItem(printer.id)}
                            className='btn btn-sm btn-outline-purple me-2' type='button'>
                            <i className="bi bi-pencil-square"></i>
                          </button>
                          <button
                            onClick={() => selectَItemToDelete(printer)}
                            className='btn btn-sm btn-outline-danger' type='button'>
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {filterModel.parts > 1 &&
                  <nav aria-label="Page navigation example" className='mt-5'>
                    <ul className="pagination justify-content-center">
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(false) }}>
                          <i className="bi bi-chevron-compact-right"></i>
                        </a>
                      </li>
                      {makePagerItems()}
                      <li className="page-item mx-1">
                        <a className="page-link circular-pagination" onClick={() => { movePagerPart(true) }}>
                          <i className="bi bi-chevron-compact-left"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                }
              </div>
            </div>
          </>
        }
      </>
    )
  };

  const openNewForm = async () => {
    resetForm();
    setShowFormModal(true);
  };

  const closeModal = () => {
    resetForm();
    setShowFormModal(false);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const selectَItemToDelete = (unit) => {
    setFormModel(unit);
    setShowDeleteModal(true);
  };

  const deleteItem = async (id) => {
    setLoading(true);
    try {
      const resp = await apiMethod.removePrinter(formModel.id);
      if (!methods.showApiErrors(resp))
        return false;

      await getGridData();

      resetForm();
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      setShowDeleteModal(false);
    }
    return true;
  };

  const Modal = () => {
    return (
      <div className="modal fade show" tabIndex="-1" role="dialog" style={{ display: showFormModal ? 'block' : 'none' }}>
        <div className="modal-dialog modal-md" role="document" >
          <div className="modal-content px-3">
            <div className="modal-header">
              <h5 className="modal-title">ایجاد / ویرایش پرینتر</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
              </button>
            </div>
            <div className="modal-body">
              <div className="row g-3">
                <div className="col-md-12">
                  <label htmlFor="title" className="form-label required-label">عنوان</label>
                  <input type="text" className="form-control" id="title" name="title"
                    placeholder='عنوان'
                    value={formModel.title}
                    onChange={(e) => { setFormModel({ ...formModel, title: e.target.value }) }}
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="name" className="form-label required-label">دستگاه در شبکه</label>
                  <select
                    id="name"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.name}
                    onChange={(e) => { setFormModel({ ...formModel, name: e.target.value }) }}
                  >
                    <option value="">انتخاب دستگاه</option>
                    {localPrinters.map((item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-12">
                  <label htmlFor="ipAddress" className="form-label">IP در شبکه</label>
                  <input type="text" className="form-control" id="ipAddress" name="ipAddress"
                    placeholder='00.00.00.00'
                    value={formModel.ipAddress}
                    onChange={(e) => { setFormModel({ ...formModel, ipAddress: e.target.value }) }}
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="code" className="form-label">کد دستگاه</label>
                  <input type="text" className="form-control" id="code" name="code"
                    placeholder=''
                    value={formModel.code}
                    onChange={(e) => { setFormModel({ ...formModel, code: e.target.value }) }}
                  />
                </div>
                <div className="col-md-12">
                  <label htmlFor="printerUnitType" className="form-label required-label">جایگاه دستگاه</label>
                  <select
                    id="printerUnitType"
                    className="form-select"
                    aria-label="Default select example"
                    value={formModel.printerUnitType}
                    onChange={(e) => { setFormModel({ ...formModel, printerUnitType: e.target.value }) }}
                  >
                    <option value="0">جایگاه پرینتر</option>
                    <option value="1">صندوق</option>
                    <option value="2">آشپزخانه</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn custome-btn btn-link-purple "
                onClick={closeModal}
              >
                انصراف
              </button>
              <button type="submit" className="btn custome-btn btn-purple w-50" onClick={() => { createNewItem() }}
              >ثبت وذخیره</button>
            </div>
          </div >
        </div >
      </div >
    )
  };

  return (
    <>
      {renderItems()}
      {showFormModal && Modal()}
      {showDeleteModal &&
        <DeleteModal
          showModal={showDeleteModal}
          closeModal={closeDeleteModal}
          deleteItem={deleteItem}
          text={'پرینتر'}
        />
      }
    </>
  );
}

export default Printer;